export default __webpack_public_path__ + "static/media/spikes.56aa2cd9.svg";